import React from 'react'
import { styled } from "../../../stitches.config";
import BrandCard from './BrandCard';
import Logo from "../../atoms/Logo";
import { ReactComponent as CircleIcon } from '../../assets/icons/circles-empty-icon.svg?react';


type BrandsProps = {
    isDarkMode: boolean | undefined
}

type BrandCardTypes = {
    brand: Config.Brand,
    text: string
}

const BrandCards: BrandCardTypes[] = [
    {
        brand: 'natemat',
        text: 'To unikatowe miejsce dla wszystkich, którzy chcą trzymać rękę na pulsie. Pokazujemy to, co najważniejsze i najciekawsze. Informujemy, tłumaczymy, jesteśmy blisko tego, czym naprawdę żyją Polacy i co budzi ich emocje.'
    },
    {
        brand: 'mamadu',
        text: 'Miłość, rodzina, uroda, porady, dobre życie, lifestyle. Dowiesz się, co warto obejrzeć, gdzie spędzić weekend i jak wydać na kosmetyki minimum, osiągając maksimum. Wiemy, czym żyją kobiety i chcemy im w tym towarzyszyć.'
    },
    {
        brand: 'aszdziennik',
        text: 'Redakcja, która istnieje naprawdę. ASZdziennik każdego dnia walczy o newsy, które najlepiej opisują rzeczywistość. Aha, a czasami też coś zmyśla.'
    },
    {
        brand: 'innpoland',
        text: 'Zaktualizowany, odmłodzony, lepszy. W INNPoland inspirujemy biznes, wspieramy startupy, tłumaczymy technologie na język zwykłych śmiertelników.'
    },
    {
        brand: 'dadhero',
        text: 'Nowoczesny lifestyle w męskim wydaniu. Uwaga: mamy własne zdanie prawie na każdy temat.'
    }
]

const Brands = ({ isDarkMode }: BrandsProps) => {
    return (
        <BrandWrapper>
            <BrandRow>
                {
                    BrandCards.map((item, index) => {
                        if (index < 3) {
                            return (
                                <BrandCard text={item.text} key={index}>
                                    <Circle className={`${item.brand}-circles`}>
                                        <CircleIcon />
                                    </Circle>
                                    <Logo type={isDarkMode ? "dark" : "white"} brand={item.brand} className={`${item.brand}logo`} />
                                </BrandCard>
                            )
                        }
                    })
                }
            </BrandRow>
            <BrandRow>
                {
                    BrandCards.map((item, index) => {
                        if (index > 2) {
                            return (
                                <BrandCard text={item.text} key={index}>
                                    <Circle className={`${item.brand}-circles`}>
                                        <CircleIcon />
                                    </Circle>
                                    <Logo type={isDarkMode ? "dark" : "white"} brand={item.brand} className={`${item.brand}logo`} />
                                </BrandCard>
                            )
                        }
                    })
                }
            </BrandRow>
        </BrandWrapper>
    )
}

export default Brands;

const BrandWrapper = styled('div', {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    flexWrap: 'wrap',
    width: '90%',
    '@bp4': {
        gap: '24px',
        width: '90%',
        '&>div:first-child>div': {
            minHeight: '408px',
        }
    }
})

const BrandRow = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    '@bp4': {
        flexDirection: 'row',
        gap: '24px',
    }
})

const Circle = styled('div', {
    position: 'absolute',
    bottom: -5,
    right: 0,
    '@bp4': {
        width: '72px',
        height: '160px',
        bottom: 0,
        right: 0,
        'svg': {
            width: '100%',
            height: '100%',
        }
    }
})